import { useEffect } from 'react';

// iOS Safari anchors position:fixed to the layout viewport, so the on-screen keyboard
// covers the bottom bar instead of pushing it up. Measure the overlap and hand it to CSS.
const NOISE_THRESHOLD_PX = 40;

export default function useKeyboardInset() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const root = document.documentElement;

    const update = () => {
      const overlap = window.innerHeight - viewport.height - viewport.offsetTop;
      const inset = overlap > NOISE_THRESHOLD_PX ? Math.round(overlap) : 0;
      root.style.setProperty('--keyboard-inset', `${inset}px`);
      root.classList.toggle('keyboard-open', inset > 0);
    };

    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);

    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      root.style.removeProperty('--keyboard-inset');
      root.classList.remove('keyboard-open');
    };
  }, []);
}
